import { ActionButton } from "../../../components/Forms/ActionButton";

const Card = ({ image, size, uploaded, name }) => {

    const renderSize = (size) => {
        if (size < 1024) return `${size} Bytes`;
        else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        else return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };
    
    return (
        <div className="flex flex-col bg-white shadow-[0px_4px_25px_rgba(94,92,154,0.1)] min-w-64 max-w-80 flex-1 p-2 rounded-md">
            <img src={image} alt="media" className="w-full min-h-40 max-h-64 rounded-md object-cover" />
            <div className="flex flex-col justify-between h-[-webkit-fill-available;]">
                <p className="text-lg font-semibold overflow-x-scroll mt-5">{name}</p>
                <div className="flex flex-col justify-between">
                    <div className="flex items-center justify-between mt-2">
                        <p className="text-xs text-secondary">Size</p>
                        <p className="text-xs text-secondary">{renderSize(size)}</p>
                    </div>
                    <div className="flex items-center justify-between">
                        <p className="text-xs text-secondary">Uploaded</p>
                        <p className="text-xs text-secondary">{uploaded}</p>
                    </div>
                    <div className="mt-2 flex flex-col gap-2">
                        <ActionButton
                            variant={'submit'}
                            text={'Download'}
                            handleSubmit={() => window.open(image, '_blank')}
                        />
                        <ActionButton
                            variant={'reset'}
                            text={'View'}
                            handleSubmit={() => window.open(image, '_blank')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Card;